import React from 'react';
import PropTypes from 'prop-types';
import { UploadedPhoto } from '../../prop-types';
import SliderControl from '../../common/advanced-editor/slider-control';
import IU from '../../../_utils/img/img-utils';
import Button from '../../../_common/button';
import FilterButtons from '../../common/advanced-editor/filter-buttons';
import Navigation from '../../common/advanced-editor/navigation';

const { zoomHelpers } = IU;

export function SliderControlsPanel({
  photo,
  sizeArea,
  zoomSliderRef,
  tiltSliderRef,
  brightnessSliderRef,
  initialZoom,
  handleZoom,
  handleStraighten,
  handleBrightness,
  handleRotate,
  handleEffect,
  effectUrls,
  close,
  handleReset,
  handleApply,
  disabled,
}) {
  const imageId = (photo || {}).image_id;

  return (
    <div className="advanced-editor__slider-controls-panel h-100 d-flex flex-column">
      <h3 className="text-center mt-3">Edit Photo</h3>
      <div className="d-flex flex-column mt-3">
        <fieldset className="form-group">
          <legend className="h5 font-weight-bold">Rotate</legend>
          <div className="btn-toolbar mt-2">
            <Button
              type="button"
              className="edit-btn rotate-acw"
              onClick={() => handleRotate({ angle: -IU.RIGHT_ANGLE })}
              hideLabel
              disabled={disabled}>
              Rotate 90 degrees anticlockwise
            </Button>
            <Button
              type="button"
              className="edit-btn rotate-cw ml-3"
              onClick={() => handleRotate({ angle: IU.RIGHT_ANGLE })}
              hideLabel
              disabled={disabled}>
              Rotate 90 degrees clockwise
            </Button>
          </div>
        </fieldset>
        <SliderControl
          sliderRef={zoomSliderRef}
          label="Zoom"
          id="zoom-slider"
          className="form-group w-100 mt-1"
          onChange={handleZoom}
          value={
            zoomHelpers.getZoom(imageId) ||
            zoomHelpers.getZoomFromPhotoData(photo, sizeArea) ||
            initialZoom
          }
          min={initialZoom}
          max={2.5}
          disabled={disabled}
        />
        <SliderControl
          sliderRef={tiltSliderRef}
          label="Tilt"
          id="tilt-slider"
          className="form-group w-100 mt-1"
          min={-20}
          max={20}
          threshold={100}
          value={zoomHelpers.getStraighten(imageId)}
          onChange={handleStraighten}
          disabled={disabled}
        />
        <SliderControl
          sliderRef={brightnessSliderRef}
          label="Brightness"
          id="brightness-slider"
          className="form-group w-100 mt-1"
          min={5}
          max={15}
          threshold={100}
          value={zoomHelpers.getBrightness(imageId)}
          onChange={handleBrightness}
          disabled={disabled}
        />
      </div>
      <fieldset className="form-group mt-1 advanced-editor__filters">
        {photo && (
          <FilterButtons
            key={photo.fx}
            defaultValue={photo.fx}
            urls={effectUrls}
            onChange={handleEffect}
            disabled={disabled}
          />
        )}
      </fieldset>
      <Navigation
        handleReset={handleReset}
        handleApply={handleApply}
        close={close}
        disabled={disabled}
      />
    </div>
  );
}

SliderControlsPanel.propTypes = {
  photo: UploadedPhoto,
  initialZoom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  effectUrls: PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  }),
  zoomSliderRef: PropTypes.func.isRequired,
  tiltSliderRef: PropTypes.func.isRequired,
  brightnessSliderRef: PropTypes.func.isRequired,
  handleZoom: PropTypes.func.isRequired,
  handleStraighten: PropTypes.func.isRequired,
  handleBrightness: PropTypes.func.isRequired,
  handleRotate: PropTypes.func.isRequired,
  handleEffect: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleApply: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sizeArea: PropTypes.arrayOf(PropTypes.number),
};

SliderControlsPanel.defaultProps = {
  photo: null,
  effectUrls: {},
  disabled: false,
};
